module.exports = __webpack_public_path__ + "static/media/Corsario.d10c30c3.jpg";